import tgAxios, { ApiResponse } from "@/api/api-axios";
import { LoginResponse } from "@/modules/authentication/types/auth.types";

export const loginApi = (
  email: string,
  password: string
): Promise<LoginResponse> => {
  return tgAxios.post(`/user/login`, { email, password });
};

export const logoutApi = (
  refreshToken: string,
  logoutAll: boolean
): Promise<ApiResponse> => {
  return tgAxios.post(`/user/logout`, { refreshToken, logoutAll });
};
export const register = ({
  email,
  password,
}: {
  email: string;
  password: string;
}): Promise<ApiResponse> => {
  return tgAxios.post(`/user/register`, { email, password });
};
export const resetPasswordApi = (email: string): Promise<ApiResponse> => {
  return tgAxios.post(`/user/reset-password`, { email });
};
export const confirmResetPasswordApi = (
  token: string,
  newPassword: string
): Promise<ApiResponse> => {
  return tgAxios.post(`/user/reset-password/confirm`, { token, newPassword });
};
export const googleLoginApi = (idToken: string): Promise<LoginResponse> => {
  return tgAxios.post(`/user/login/google`, { idToken });
};

export const zaloLoginApi = (oauth_code: string): Promise<LoginResponse> => {
  return tgAxios.post(`/user/login/zalo`, { code: oauth_code });
};
export const refreshTokenApi = (refreshToken: string): Promise<LoginResponse> => {
  return tgAxios.post(`/user/refresh`, { refreshToken });
};
